import { Component, input, output } from '@angular/core';
import { ChartComponent, LineInputs } from '@charts';
import { ChartOptions } from 'chart.js';

@Component({
  selector: 'ui-line-chart',
  imports: [ChartComponent],
  template: `
    <chart
      [type]="'line'"
      [options]="options()"
      [typeInputs]="lineInputs()"
      (changeVisibility)="changeVisibility.emit($event)"
    />
  `,
})
export class LineChartComponent {
  options = input<ChartOptions<'line'>>();

  lineInputs = input.required<LineInputs>();
  changeVisibility = output<any>();
}
